import { render } from "./SelectModel.vue?vue&type=template&id=3885e3b6"
import script from "./SelectModel.vue?vue&type=script&lang=js"
export * from "./SelectModel.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SelectModel.vue?vue&type=style&index=0&id=3885e3b6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__